  <button
    type="button"
    class="floating-assistant-btn btn btn-primary"
    aria-label="Open BCX Assist"
    title="BCX Assist"
    @click="$emit('open-assistant')"
  >
    <i class="bi bi-robot fs-5"></i>
  </button>
